export default {
    title: 'Cazino Constanta - bilete online',
    search: 'Cauta',
    all_states: 'Toate judetele',
    all_museums: 'Muzee disponibile',
    homepage_title: 'Vizitează Cazinoul din Constanța',
    homepage_desc: 'Un simbol etern al eleganței de la malul Mării Negre.',
    cart: 'Cos de cumparaturi',
    no_tickets: 'Niciun bilet',
    checkout: 'Finalizeaza comanda',
    ticket: 'bilet',
    next_step: 'Pasul urmator',
    select_tickets: 'Selecteaza bilete',
    read_more: 'Citeste mai mult',
    read_less: 'Citeste mai putin',
    museums: 'Muzee',
    login: 'Autentificare',
    my_account: 'Contul meu',
    register: 'Cont nou',
    create_account: 'Creează cont',
    create_account_desc:'pentru acces facil la istoricul comenzilor tale',
    continue_as_guest: 'Continua fara cont',
    email: 'Adresa de email',
    email_address: 'Email',
    phone: 'Telefon',
    firstName: 'Prenume',
    lastName: 'Nume',
    password: 'Parola',
    confirm_password: 'Confirma parola',
    accept_newsletter: 'Doresc sa ma abonez la newsletter',
    send_sms: 'Doresc sa primesc biletele si prin sms',
    terms_conditions: 'termenele si conditiile',
    authentication: 'Autentificare',
    use_form_below: 'Foloseste formularul de mai jos pentru a te autentifica si a avea acces la biletele tale',
    forgot_password: 'Am uitat parola',
    new_account: 'Cont Nou',
    new_user: 'Client nou',
    reset_password: 'Resetati parola',
    enter_email_to_reset_password: 'Introduceti adresa de email a contului pentru a reseta parola',
    reset_password_button: 'Reseteaza parola',
    follow_email_instructions: 'Urmareste instructiunile trimise pe email pentru a-ti reseta parola.',
    terms_and_conditions: 'Termeni si conditii',
    response_payment: 'Raspuns plata',
    payment_confirmed_congratulations: 'Plata a fost confirmata. Felicitari!',
    open_e_ticket: 'Deschide E-BILET',
    order_not_confirmed_error_message: 'Comanda nu a putut fi confirmata. Mesaj de eroare:',
    please_try_again_to_purchase_tickets: 'Te rugam sa incerci din nou achizitionarea de bilete.',
    please_pay_again_tickets: 'Te rugam sa incerci din nou plata biletelor. Locurile sunt blocate pentru tine pana la',
    museum_list: 'Lista muzee',
    back: 'Inapoi',
    orders: 'Comenzi',
    personal_info: 'Date personale',
    change_password: 'Schimba parola',
    exit: 'Iesire',
    no_orders: 'Nu ai nici o comanda',
    save: 'Salveaza',
    current_password: 'Parola curenta',
    new_password: 'Parola noua',
    delete: 'Șterge',
    tickets_total: 'Total bilete',
    tax: 'Taxe procesare comanda',
    total_payment: 'Total de plata',
    pay: 'Plateste',
    pay_again: 'Plateste din nou',
    continue_shopping: 'Cumpara si alte bilete',
    tickets_email: 'Aici vei primi biletele',
    modify: 'Modifica',
    my_cart: 'Cosul meu',
    user_details: 'Detalii utilizaor',
    payment: 'Plata',
    terms: 'Termeni si conditii',
    gdpr: 'Termeni GDPR',
    last_tickets: 'Ultimele bilete',
    sold_out: 'Epuizat',
    pick_tickets: 'Alege bilete',
    not_found_order: 'Comanda inexistenta',
    expiration_date: 'Data expirare',
    open_eticket: 'Deschide E-BILET',
    payment_method: 'Metoda de plata',
    delivery_method: 'Metoda de livrare',
    show_details: 'vezi detalii',
    hide_details: 'ascunde detalii',
    Confirmat: 'Confirmat',
    Neconfirmat: 'Neconfirmat',
    Anulat: 'Anulat',
    tickets: 'Bilete',
    my_order: 'Comanda mea',
    what_to_visit: 'Ce poti vizita',
    Adult: 'Adult',
    Elev: 'Elev',
    Student: 'Student',
    Pensionar: 'Pensionar',
    'Castelul Peleș (expoziția de bază)': 'Castelul Peleș (expoziția de bază)',
    'Castelul Peleș (tur opțional 1)': 'Castelul Peleș (tur opțional 1)',
    'Castelul Pelișor': 'Castelul Pelișor',
    'Castelul Peleș': 'Castelul Peleș',
    go_to_schedule: 'Vezi programul de vizitare',
    faqs: 'Intrebari frecvente',
    faqs_q_1: 'Cine beneficiază de gratuitate la vizitarea Muzeului Național Peleș?',
    faqs_a_1: 'Beneficiază de gratuitate la biletele de intrare în muzee, pe baza documentelor justificative:<li>Copii preșcolari (până în vârsta de 7 ani);</li><li>Copiii în vârstă de până la 18 ani, pe perioada vacanțelor;</li><li>Elevii și studenții cetățeni români din afara granițelor țării, bursieri ai statului român;</li><li>Copiii în vârstă de până la 18 ani, care au nevoi speciale sau cu handicap , precum și pentru persoana însoțitoare a copilului în vârstă de până la 18 ani cu handicap;</li><li>Copii în vârstă de până la 18 ani cărora li se aplică măsuri sociale de protecție;</li><li>Adulți cu handicap grav sau accentuat, precum și persoana care îi însoțește;</li><li>Posesorii de carduri Euro 26, cu vârsta de până la 30 ani, în fiecare zi de 26 din fiecare lună, atunci când aceasta cade într-o zi când instituția este deschisă pentru public; dacă 26 cade într-o zi când instituția este închisă pentru public, atunci gratuitatea se acordă în ziua lucrătoare imediat următoare a lunii;</li><li>Pensionarii din rețeaua muzeală, posesori de adeverințe/legitimații pentru acces gratuit;</li><li>Posesorii cardurilor ICOM;</li><li>Cadrul didactic însoțitor, la un numar de 20 de elevi vizitatori, la vizitarea expoziției de bază a castelului Peleș și a castelului Pelișor. Pentru vizitarea tururilor opționale, la un număr de 20 de elevi vizitatori, un cadru didactic însoțitor beneficiază de reducere de 75% din tariful pentru vizitatori adulți;</li><li>Pensionarii, în data de 1 octombrie, atunci când se sărbătorește Ziua Internațională a Persoanelor Vârstnice;</li><li>Delegațiile oficiale, precum și pentru alte delegații cu caracter cultural, în limita programului de funcționare al muzeului;</li><li>Angajații rețelei muzeale, ai Ministerului Culturii și ai serviciilor deconcentrate ale Ministerului Culturii;</li><li>Angajații Institutului Național de Cercetare în Domeniul Conservării și Restaurării;</li><li>Reprezentanți mass-media;</li><li>Adulții cu handicap mediu și ușor beneficiază de reducere 75% din tariful perceput adulților pentru accesul la muzeele aflate în subordinea Ministerului Culturii.</li><br/>Mai multe detalii <a href="https://peles.ro/ro/program-si-taxe/" target="new" style="color: red;">aici</a>.',
    faqs_q_2: 'Cum pot cere rambursarea biletelor achiziționate online?',
    faqs_a_2: 'În cazul în care biletele tale sunt eligibile pentru a fi rambursate, poți cere rambursarea trimițând un email la adresa contact[at]peles.ro.',
    faqs_q_3: 'Cum pot primi factura fiscală pentru biletele comandate online?',
    faqs_a_3: 'Pentru a solicita factura fiscală pentru comanda plasată pe bilete.peles.ro completează <a href="/factura" style="color: red;">formularul de solicitare</a> a facturii fiscale. Factura fiscală va fi emisă după efectuarea vizitei la muzeu.',
    easter_schedule: 'Program de Paste',
    friday: 'Vineri',
    saturday: 'Sambata',
    sunday: 'Duminica',
    monday: 'Luni',
    tuesday: 'Marti',
    tickets_desk_close: 'Casa de bilete se închide la ora 13:00',
    closed: 'Inchis',
    last_enter: 'ultima intrare',
    last_enter_floor: 'ultima intrare pentru turul de parter',
    last_enter_optional: 'Ultima intrare pentru turul opțional I se face la ora 12:30',
    school_children: 'Elevii beneficiază de intrare gratuită pe perioada vacanțelor școlare.',
    under7: 'Copiii în vârstă de până la 7 ani beneficiază de intrare gratuită.',
    refund_policy: 'Politica de retur',
    refund_detail_1: 'Biletele online cumpărate de pe www.bilete.peles.ro au o valabilitate de 14 zile. Dacă termenul de 14 zile a fost depășit fără a utiliza biletul, valoarea biletului nu se returnează.',
    refund_detail_2: 'În cazul în care biletul online a fost validat prin scanarea codului QR la intrarea în muzeu, biletul este considerat utilizat si nu mai poate fi rambursat.',
    refund_detail_3: 'Potrivit OUG 34/2014, dacă sunteți consumator (persoana fizică) aveți dreptul de vă retrage din contract, fără vreun motiv anume, în termen de 14 zile din ziua în care dumneavoastră sau o terță parte mandatată de dumneavoastră, a intrat în posesia biletelor. Astfel, puteți trimite solicitarea de retragere completând formularul <a href="/refund" style="color: red;">cerere de returnare a contravalorii biletului</a>.',
    refund_detail_4: 'După returnarea contravalorii biletului cumpărat online, acesta va fi invalidat și nu va mai putea fi folosit.',
    refund_detail_5: 'În cazul returnărilor, prețul tipărit pe bilet va fi returnat integral. Nu poate fi solicitat pentru returnare un preț parțial. Clientul își asumă întreaga responsabilitate pentru realizarea completă a tururilor opționale. Nu poate fi solicitată rambursarea parțială a unui bilet, dacă clientul a decis să nu efectueze complet turul pentru care a achiziționat bilet electronic. Returnarea valorii biletelor se va face în contul valabil din care s-a făcut plata inițială.',
    refund_detail_6: 'În cazul anulării, amânării sau modificărilor majore de program sau distribuție, nicio altă cheltuială adiacentă (de transport, cazare, taxe de livrare sau alte taxe) nu va fi returnată. Muzeul Național Peleș va putea returna, în caz de anulare a comenzii, doar prețul biletului înscris pe acesta.',
    refund_title: 'Cerere de returnare a contravalorii biletului',
    ticket_identificator: 'Seria biletului/ID comandă/Data achiziției',
    refund_info: 'Banii vor fi returnați în contul din care ați făcut plata. Se returnează contravaloarea biletelor, nu și valoarea taxei de procesare a tranzacției.',
    refund_bank_details: 'Detaliile contului bancar în care doriți să vă returnăm valoarea biletului (numele, prenumele, numele băncii, cod IBAN)',
    refund_reason: 'Motivul pentru care doriți returnarea banilor',
    refund_request_ok: 'Cererea de retur a fost trimisa cu succes.',
    refund_request_error: 'Cererea de retur nu a putut fi trimisa cu succes. Verificati numarul de comanda ca este corect introdus.',
    refund_aggree: 'Sunt de acord ca, în conformitate cu prevederile Regulamentului UE nr. 679/2016 și cu celelalte acte normative aflate în vigoare în materia protecției datelor cu caracter personal, datele cu caracter personal furnizate de către mine (nume şi prenume, adresă sau reședință, adresă e-mail, informații bancare) să fie prelucrate de către Muzeul Național Peleș în scopul procesarii cererii de rambursare.', 
    contact_technical: 'Detalii tehnice achizitie bilete',
    contact_museum: 'Detalii vizitare, ghidaj',
    confirm_hour_add_title: 'Atentie!',
    confirm_hour_add_msg: 'Castelul s-a inchis pentru ziua de astazi!',
    Cancel: 'Renunta',
    add_to_cart: 'Adauga in cos',
    mandatory_field: 'Câmpul este obligatoriu.',
    wrong_email: 'Email invalid.',
    password_mismatch: 'Parolele nu se potrivesc.',
    terms_mandatory: 'Va rugam sa acceptati termenii si conditiile.',
    phone_invalid: 'Numărul de telefon nu este valid.',
    access_interval: 'Interval intrare',
    hour: 'Ora',
    price: 'pret',
    info_fewer_tickets: 'Au fost selectate mai putine locuri decat dorite',
    could_not_select_all: 'Nu s-au putut selecta toate biletele.',
    info_no_tickets: 'Nu mai sunt bilete disponibile',
    could_not_select: 'Eroare selectie bilete',
    access_interval_date: 'Perioada',
    date: 'Data',
    pick_hour: 'Selecteaza ora',
    select_date: 'Selecteaza ziua',
    sector: 'sector',
    section: 'sectiune',
    row: 'rand',
    seat: 'loc',
    youveSelected: 'Ai selectat',
    ticketSingular: 'bilet',
    ticketPlural: 'bilete',
    automatic_selection: 'Alege cele mai bune locuri',
    manual_selection: 'Selecteaza din schema salii',
    selectFail: 'Nu s-a putut selecta biletul',
    apply_voucher: 'Aplica voucher',
    voucher_code: 'Cod voucher',
    invalid_voucher: 'Cod voucher invalid',
    voucher_applied: 'Voucher aplicat cu succes',
    price_legend: 'Legenda preturi',
    invoice: 'Factura',
    invoice_info: 'Dacă dorești factură fiscală pentru comanda ta pe bilete.peles.ro, te rugăm să completezi cu atenție formularul de mai jos.',
    transaction_id: 'Numar comanda',
    visit_date: 'Data efectuării vizitei',
    full_name: 'Nume și prenume',
    company_name: 'Denumire firmă',
    cui: 'CUI',
    reg_com: 'Registrul Comerțului',
    address: 'Adresă sediu social/Adresă',
    bank: 'Banca',
    iban: 'Cont (IBAN)',
    invoice_type: 'Tipul facturii',
    country: 'Țara',
    company_representative: 'Reprezentantul companiei',
    company: 'Persoana juridică',
    individual: 'Persoană fizică',
    barcode: 'Cod de bare al unui bilet',
    barcode_invoice_info: 'pentru a demonstra posesia biletului',
    email_address_invoice_info: 'adresa de e-mail la care dorești să primești factura',
    invoice_aggree: 'Sunt de acord ca, în conformitate cu prevederile Regulamentului UE nr. 679/2016 și cu celelalte acte normative aflate în vigoare în materia protecției datelor cu caracter personal, datele cu caracter personal furnizate de către mine (nume şi prenume, adresă sau reședință, adresă e-mail, informații bancare) să fie prelucrate de către Muzeul Național Peleș în scopul emiterii facturii fiscale.',
    invoice_send: 'Trimite',
    invoice_request_ok: 'Cererea de factura a fost trimisa cu succes.',
    invoice_generated_ok: 'Factura a fost generata cu succes si trimisa pe adresa de email completata.',
    invoice_request_error: 'Cererea de factura nu a putut fi trimisa cu succes. Verificati numarul de comanda si codul de bare ca sunt corecte.',
    invoice_already_printed: 'Factura a fost deja generata.',
    invalid_cui: 'CUI-ul introdus nu este valid.',
    cookie_banner_text: 'Acest site folosește cookie-uri pentru a analiza traficul și a-ți îmbunătăți experiența de navigare.',
    cookie_learn_more: 'Află mai multe',
    cookie_accept: 'Accept toate',
    cookie_decline: 'Refuz opționalele'
}